import { supabase } from '../../../services/supabase';

export const getTicketPreviousStatus = async (
  ticketId: string | undefined,
): Promise<
  { blockers: string; completion_percentage: number; wip_links: string }[]
> => {
  if (!ticketId) return [];
  const { data, error } = await supabase
    .from('ticket_check_ins')
    .select('blockers, completion_percentage, wip_links')
    .eq('ticket_id', ticketId)
    .order('created_at', { ascending: false })
    .limit(1);
  if (error) {
    console.error(error);
    return [];
  }
  return data;
};
